import { render } from "./ButtonComponent.vue?vue&type=template&id=694a0d33"
import script from "./ButtonComponent.vue?vue&type=script&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&lang=js"

import "./ButtonComponent.vue?vue&type=style&index=0&id=694a0d33&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__